import { EVENT_STATUS, TYPECONTENT } from '../constants/TrackingConstants';

export default function getDeliveryWinner(eventType, typeContent) {
  const result = {
    eventType,
    deliveryWinner: null,
  };
  if (typeContent === TYPECONTENT.AD) {
    if (eventType === EVENT_STATUS.DELIVERY) {
      result.deliveryWinner = '0';
      result.eventType = EVENT_STATUS.DELIVERY;
    } else if (eventType === EVENT_STATUS.DELIVERY_WINNER) {
      result.deliveryWinner = '1';
      result.eventType = EVENT_STATUS.DELIVERY;
    } else if (eventType === EVENT_STATUS.IMPRESSION) {
      result.deliveryWinner = '1';
    }
  }

  return result;
}
